import { createFileRoute } from '@tanstack/react-router';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';
import NoAccess from 'src/features/auth/components/NoAccess';

export const Route = createFileRoute('/_auth/no-access')({
  head: () => ({
    meta: [{ title: 'No Access | Tekst' }],
  }),
  component: NoAccessPage,
});

function NoAccessPage() {
  function handleSupport() {
    window.location.href = 'https://support.tekst.com';
  }

  return (
    <AuthProvider>
      <NoAccess redirectUrl="/login" className="w-[450px] h-[300px]" handleSupport={handleSupport} />
    </AuthProvider>
  );
}
